import React from 'react'
import styled from 'styled-components'

import {
  makeTranslationAware
} from '../../../utils'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 32px;
`

const DefaultTitle = styled.span`
  color: ${({ theme }) => theme.colors.secondary };
  font-size: 3rem;
  font-weight: bold;
  text-transform: uppercase;
`


export const RawTitleBar = ({
  children,
  Component = DefaultTitle,
}) => {
  return (
    <Container>
      <Component>
        { children }
      </Component>
    </Container>
  )
}

const TranslatedTitleBar = makeTranslationAware(RawTitleBar)
TranslatedTitleBar.displayName = 'TranslatedTitleBar'

export default TranslatedTitleBar



// WEBPACK FOOTER //
// ./src/components/atoms/TitleBar/TitleBar.js